var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1919.248,
    height: 319.308,
    viewBox: "1.787 1009.173 1919.248 319.308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Stars"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.165 1063.507a3.075 3.075 0 0 0 .18-1.057 3.11 3.11 0 0 0-.15-.969c-.234-.712-.719-1.202-1.28-1.202-.536 0-1.003.45-1.248 1.113a3.077 3.077 0 0 0-.18 1.058c0 .707.222 1.335.567 1.731a1.151 1.151 0 0 0 .862.439c.537 0 1.004-.449 1.249-1.113Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.963 1135.928a3.077 3.077 0 0 0 .181-1.058c0-.707-.223-1.335-.567-1.731a1.151 1.151 0 0 0-.862-.44 1.125 1.125 0 0 0-.813.385c-.373.392-.617 1.046-.617 1.786a3.11 3.11 0 0 0 .15.968c.234.713.72 1.202 1.28 1.202a1.125 1.125 0 0 0 .812-.384c.18-.189.33-.438.436-.728Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.994 1263.793a1.125 1.125 0 0 0 .812-.384c.373-.392.617-1.046.617-1.786a3.113 3.113 0 0 0-.15-.968 2.218 2.218 0 0 0-.417-.763 1.151 1.151 0 0 0-.862-.44c-.79 0-1.43.972-1.43 2.17 0 .708.222 1.336.567 1.732a1.152 1.152 0 0 0 .863.44Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.185 1284.851a1.125 1.125 0 0 0 .812-.384c.373-.392.617-1.046.617-1.786a3.115 3.115 0 0 0-.15-.968c-.234-.713-.719-1.203-1.28-1.203a1.125 1.125 0 0 0-.812.385c-.18.188-.33.438-.436.728a3.076 3.076 0 0 0-.181 1.058 3.11 3.11 0 0 0 .15.968c.099.301.242.562.417.763a1.152 1.152 0 0 0 .863.44Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66 1192.727a3.074 3.074 0 0 0 .18-1.058c0-.707-.222-1.335-.567-1.73a1.152 1.152 0 0 0-.862-.44 1.125 1.125 0 0 0-.813.385c-.18.188-.329.437-.436.728a3.076 3.076 0 0 0-.18 1.057 3.106 3.106 0 0 0 .154.983c.236.705.718 1.188 1.275 1.188a1.126 1.126 0 0 0 .812-.385c.18-.188.33-.438.437-.728Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 205"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.787 1170.99a3.075 3.075 0 0 0 .181-1.057 3.11 3.11 0 0 0-.15-.968 2.219 2.219 0 0 0-.417-.763 1.152 1.152 0 0 0-.863-.44 1.125 1.125 0 0 0-.812.385c-.372.392-.617 1.046-.617 1.786a3.111 3.111 0 0 0 .15.968c.1.301.243.562.418.763a1.151 1.151 0 0 0 .861.44c.537 0 1.005-.45 1.25-1.113Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.688 1173.285a3.076 3.076 0 0 0 .18-1.058 3.11 3.11 0 0 0-.15-.968 2.219 2.219 0 0 0-.417-.763 1.152 1.152 0 0 0-.862-.439 1.125 1.125 0 0 0-.813.385c-.18.188-.329.438-.436.728a3.078 3.078 0 0 0-.18 1.057c0 .708.222 1.336.567 1.732a1.151 1.151 0 0 0 .862.439c.537 0 1.005-.45 1.25-1.113Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.321 1309.097a1.43 2.17 0 1 1 0 1",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Ellipse 44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.571 1145.31a3.075 3.075 0 0 0 .181-1.057 3.111 3.111 0 0 0-.15-.968 2.218 2.218 0 0 0-.417-.763 1.152 1.152 0 0 0-.863-.44 1.126 1.126 0 0 0-.813.385c-.18.189-.329.438-.436.729a3.075 3.075 0 0 0-.18 1.057 3.111 3.111 0 0 0 .15.968c.098.301.242.562.417.763a1.152 1.152 0 0 0 .862.44c.537 0 1.005-.45 1.25-1.114Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 210"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.332 1026.396a3.075 3.075 0 0 0 .181-1.058c0-1.199-.64-2.17-1.43-2.17a1.125 1.125 0 0 0-.812.384c-.373.392-.617 1.046-.617 1.786a3.113 3.113 0 0 0 .15.968c.099.301.242.562.417.763a1.151 1.151 0 0 0 .862.44 1.126 1.126 0 0 0 .813-.385c.18-.189.33-.438.436-.728Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.607 1221.83a3.074 3.074 0 0 0 .18-1.056c0-1.199-.64-2.17-1.428-2.17a1.126 1.126 0 0 0-.813.384c-.18.188-.33.438-.436.728a3.075 3.075 0 0 0-.181 1.058 3.11 3.11 0 0 0 .15.968c.234.712.72 1.202 1.28 1.202a1.124 1.124 0 0 0 .812-.385c.18-.188.329-.438.436-.728Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 215"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.924 1069.444a1.43 2.17 0 1 1 0 1",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Ellipse 45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.02 1022.026a3.076 3.076 0 0 0 .18-1.058c0-1.198-.64-2.17-1.43-2.17-.536 0-1.004.45-1.248 1.113a3.072 3.072 0 0 0-.181 1.057 3.112 3.112 0 0 0 .15.969c.234.712.72 1.202 1.28 1.202a1.125 1.125 0 0 0 .813-.385c.18-.188.329-.438.436-.728Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.43 1130.108c0 1.198-.64 2.17-1.43 2.17a1.152 1.152 0 0 1-.862-.439 2.218 2.218 0 0 1-.418-.763 3.11 3.11 0 0 1-.15-.968 3.075 3.075 0 0 1 .181-1.058c.245-.664.713-1.113 1.25-1.113a1.151 1.151 0 0 1 .862.44c.344.396.567 1.024.567 1.73Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.96 1084.39a1.125 1.125 0 0 0 .812-.385c.373-.391.617-1.045.617-1.785 0-.708-.223-1.336-.567-1.732a1.152 1.152 0 0 0-.863-.439c-.79 0-1.429.971-1.429 2.17 0 .708.222 1.336.567 1.732a1.151 1.151 0 0 0 .862.439Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.199 1012.401a3.075 3.075 0 0 0 .18-1.057 3.11 3.11 0 0 0-.15-.969 2.219 2.219 0 0 0-.417-.763 1.152 1.152 0 0 0-.862-.439 1.124 1.124 0 0 0-.812.385c-.373.392-.617 1.045-.617 1.786a3.106 3.106 0 0 0 .154.982c.099.295.24.55.413.749a1.15 1.15 0 0 0 .862.439c.536 0 1.004-.449 1.249-1.113Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.49 1132.65a3.075 3.075 0 0 0 .181-1.057 3.11 3.11 0 0 0-.15-.969c-.234-.712-.72-1.202-1.28-1.202a1.125 1.125 0 0 0-.812.385c-.373.392-.617 1.045-.617 1.786a3.113 3.113 0 0 0 .15.968c.234.713.719 1.202 1.28 1.202.536 0 1.004-.449 1.248-1.113Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.487 1102.866a3.079 3.079 0 0 0 .18-1.057c0-1.198-.639-2.17-1.428-2.17-.537 0-1.005.449-1.25 1.113a3.075 3.075 0 0 0-.18 1.057 3.106 3.106 0 0 0 .154.983c.236.705.719 1.188 1.276 1.188.537 0 1.004-.45 1.248-1.114Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.792 1025.339a1.125 1.125 0 0 0 .812-.385c.373-.392.616-1.045.616-1.786 0-1.198-.639-2.17-1.428-2.17-.537 0-1.005.449-1.25 1.113a3.074 3.074 0 0 0-.18 1.057c0 1.199.64 2.17 1.43 2.17Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.485 1074.925a3.075 3.075 0 0 0 .18-1.058c0-1.199-.64-2.17-1.428-2.17a1.125 1.125 0 0 0-.813.384c-.373.392-.617 1.046-.617 1.786 0 .707.222 1.335.567 1.731a1.152 1.152 0 0 0 .863.44 1.125 1.125 0 0 0 .812-.385c.18-.189.329-.438.436-.728Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.28 1212.266a1.43 2.17 0 1 1 0 1",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Ellipse 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.454 1327.368a3.079 3.079 0 0 0 .18-1.057c0-1.198-.64-2.17-1.43-2.17-.536 0-1.003.449-1.248 1.113a3.077 3.077 0 0 0-.18 1.057 3.109 3.109 0 0 0 .154.983c.098.295.24.55.413.749a1.151 1.151 0 0 0 .862.439c.537 0 1.004-.45 1.249-1.114Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.717 1249.744a3.075 3.075 0 0 0 .181-1.057 3.108 3.108 0 0 0-.15-.968c-.234-.712-.72-1.202-1.28-1.202a1.125 1.125 0 0 0-.812.385c-.373.391-.617 1.045-.617 1.785 0 1.199.64 2.17 1.43 2.17.536 0 1.004-.449 1.248-1.113Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.346 1078.12a1.125 1.125 0 0 0 .813-.385c.372-.391.617-1.045.617-1.785 0-1.2-.64-2.17-1.43-2.17a1.126 1.126 0 0 0-.813.384c-.18.188-.329.438-.436.728a3.076 3.076 0 0 0-.18 1.058 3.113 3.113 0 0 0 .148.965c.098.3.241.56.415.762a1.154 1.154 0 0 0 .866.443Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.56 1151.83a1.125 1.125 0 0 0 .813-.384c.373-.392.617-1.045.617-1.786a3.113 3.113 0 0 0-.15-.968 2.218 2.218 0 0 0-.417-.763 1.151 1.151 0 0 0-.862-.44 1.125 1.125 0 0 0-.813.385c-.18.189-.33.438-.436.729a3.075 3.075 0 0 0-.181 1.057 3.11 3.11 0 0 0 .15.968c.234.713.72 1.202 1.28 1.202Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.568 1065.324a1.43 2.17 0 1 1 0 1",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Ellipse 56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.562 1224.145a1.126 1.126 0 0 0 .814-.385c.372-.391.616-1.045.616-1.786a3.108 3.108 0 0 0-.15-.967c-.234-.713-.72-1.202-1.28-1.202a1.125 1.125 0 0 0-.812.384c-.373.392-.617 1.045-.617 1.785 0 .708.223 1.336.567 1.732a1.151 1.151 0 0 0 .862.439Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 263"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.66 1242.178a1.125 1.125 0 0 0 .812-.384c.373-.392.617-1.046.617-1.786 0-.707-.223-1.335-.567-1.731a1.152 1.152 0 0 0-.863-.44 1.125 1.125 0 0 0-.812.385c-.373.392-.617 1.046-.617 1.786a3.113 3.113 0 0 0 .15.968c.099.301.242.562.417.763a1.151 1.151 0 0 0 .862.44Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.575 1048.655a3.075 3.075 0 0 0 .18-1.057 3.11 3.11 0 0 0-.15-.969c-.234-.712-.719-1.202-1.28-1.202-.536 0-1.003.45-1.248 1.113a3.077 3.077 0 0 0-.18 1.058c0 1.198.64 2.17 1.429 2.17a1.125 1.125 0 0 0 .813-.385c.18-.188.329-.438.436-.728Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.517 1081.351a1.125 1.125 0 0 0 .812-.384c.373-.392.617-1.046.617-1.786a3.113 3.113 0 0 0-.15-.968c-.234-.713-.719-1.202-1.28-1.202a1.125 1.125 0 0 0-.812.384c-.18.189-.33.438-.436.728a3.075 3.075 0 0 0-.181 1.058c0 .707.223 1.335.567 1.731a1.152 1.152 0 0 0 .863.44Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.366 1147.68a3.077 3.077 0 0 0 .181-1.059 3.108 3.108 0 0 0-.15-.968 2.218 2.218 0 0 0-.417-.762 1.152 1.152 0 0 0-.863-.44 1.125 1.125 0 0 0-.812.385c-.18.189-.329.438-.436.728a3.073 3.073 0 0 0-.18 1.057 3.108 3.108 0 0 0 .154.983c.098.295.24.551.412.75a1.15 1.15 0 0 0 .862.438 1.126 1.126 0 0 0 .813-.384c.18-.189.33-.438.436-.729Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.217 1239.14a1.125 1.125 0 0 0 .812-.385c.373-.392.617-1.045.617-1.785a3.113 3.113 0 0 0-.15-.969c-.234-.712-.719-1.202-1.28-1.202-.789 0-1.43.972-1.43 2.17a3.109 3.109 0 0 0 .15.969c.1.3.243.561.418.762a1.152 1.152 0 0 0 .863.44Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1806.655 1062.45a3.075 3.075 0 0 0 .181 1.057c.245.664.712 1.113 1.249 1.113a1.151 1.151 0 0 0 .862-.439c.345-.396.567-1.024.567-1.731a3.077 3.077 0 0 0-.18-1.058c-.245-.664-.712-1.113-1.249-1.113-.56 0-1.046.49-1.28 1.202a3.11 3.11 0 0 0-.15.969Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1388.857 1134.87a3.077 3.077 0 0 0 .18 1.058c.107.29.257.54.436.728a1.125 1.125 0 0 0 .813.384c.56 0 1.045-.489 1.28-1.202a3.11 3.11 0 0 0 .15-.968c0-.74-.244-1.394-.617-1.786a1.125 1.125 0 0 0-.813-.384 1.151 1.151 0 0 0-.862.439c-.345.396-.567 1.024-.567 1.731Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1871.195 1263.409a1.125 1.125 0 0 0 .812.384 1.152 1.152 0 0 0 .863-.439c.345-.396.567-1.024.567-1.731 0-1.199-.64-2.17-1.43-2.17a1.151 1.151 0 0 0-.862.439 2.218 2.218 0 0 0-.417.763 3.113 3.113 0 0 0-.15.968c0 .74.244 1.394.617 1.786Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774.003 1284.467a1.125 1.125 0 0 0 .813.384 1.152 1.152 0 0 0 .862-.439c.175-.2.319-.462.418-.763a3.11 3.11 0 0 0 .15-.968 3.076 3.076 0 0 0-.181-1.058 2.116 2.116 0 0 0-.436-.728 1.125 1.125 0 0 0-.813-.385c-.56 0-1.045.49-1.28 1.203a3.115 3.115 0 0 0-.15.968c0 .74.245 1.394.617 1.786Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1911.16 1191.67a3.074 3.074 0 0 0 .181 1.057c.107.29.257.54.436.728a1.126 1.126 0 0 0 .813.385c.556 0 1.039-.483 1.275-1.188a3.106 3.106 0 0 0 .154-.983 3.076 3.076 0 0 0-.18-1.057 2.115 2.115 0 0 0-.437-.728 1.125 1.125 0 0 0-.812-.385 1.152 1.152 0 0 0-.862.44c-.345.395-.568 1.023-.568 1.73Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 205"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1751.032 1169.933a3.075 3.075 0 0 0 .181 1.058c.245.663.712 1.112 1.249 1.112a1.151 1.151 0 0 0 .862-.439 2.22 2.22 0 0 0 .417-.763 3.111 3.111 0 0 0 .15-.968c0-.74-.244-1.394-.617-1.786a1.125 1.125 0 0 0-.812-.384 1.152 1.152 0 0 0-.862.439 2.219 2.219 0 0 0-.418.763 3.11 3.11 0 0 0-.15.968Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.132 1172.227a3.076 3.076 0 0 0 .18 1.058c.245.664.713 1.113 1.25 1.113a1.151 1.151 0 0 0 .862-.439c.344-.396.567-1.024.567-1.732a3.078 3.078 0 0 0-.181-1.057 2.114 2.114 0 0 0-.436-.728 1.125 1.125 0 0 0-.812-.385 1.152 1.152 0 0 0-.863.44 2.219 2.219 0 0 0-.417.762 3.11 3.11 0 0 0-.15.968Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1604.82 1309.097a1.43 2.17 0 1 1 0 1",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Ellipse 44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1608.248 1144.253a3.075 3.075 0 0 0 .18 1.057c.245.664.713 1.113 1.25 1.113a1.152 1.152 0 0 0 .862-.439c.175-.201.319-.462.418-.763a3.111 3.111 0 0 0 .15-.968 3.075 3.075 0 0 0-.181-1.057 2.114 2.114 0 0 0-.436-.729 1.126 1.126 0 0 0-.813-.384 1.152 1.152 0 0 0-.863.439 2.218 2.218 0 0 0-.417.763 3.111 3.111 0 0 0-.15.968Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 210"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1725.488 1025.338a3.075 3.075 0 0 0 .18 1.058c.108.29.257.54.437.728a1.126 1.126 0 0 0 .813.384 1.151 1.151 0 0 0 .862-.439c.175-.2.318-.462.417-.763a3.113 3.113 0 0 0 .15-.968c0-.74-.244-1.394-.617-1.786a1.125 1.125 0 0 0-.812-.384c-.79 0-1.43.971-1.43 2.17Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730.213 1220.774a3.074 3.074 0 0 0 .18 1.057c.108.29.257.54.437.728a1.124 1.124 0 0 0 .812.385c.56 0 1.046-.49 1.28-1.202a3.11 3.11 0 0 0 .15-.968 3.075 3.075 0 0 0-.18-1.058 2.114 2.114 0 0 0-.437-.728 1.126 1.126 0 0 0-.813-.385c-.789 0-1.43.972-1.43 2.17Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 215"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627.571 1130.108c0 1.198.64 2.17 1.43 2.17a1.152 1.152 0 0 0 .862-.439c.175-.201.319-.462.418-.763a3.11 3.11 0 0 0 .15-.968 3.075 3.075 0 0 0-.181-1.058c-.245-.664-.713-1.113-1.25-1.113a1.151 1.151 0 0 0-.862.44c-.344.396-.567 1.024-.567 1.73Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1522.229 1084.005a1.125 1.125 0 0 0 .813.385 1.151 1.151 0 0 0 .862-.44c.344-.395.567-1.023.567-1.73 0-1.2-.64-2.17-1.43-2.17a1.152 1.152 0 0 0-.862.438c-.345.396-.567 1.024-.567 1.732 0 .74.244 1.394.617 1.785Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.621 1011.344a3.075 3.075 0 0 0 .181 1.057c.245.664.713 1.113 1.25 1.113a1.15 1.15 0 0 0 .861-.439c.172-.198.314-.454.413-.75a3.106 3.106 0 0 0 .154-.981c0-.74-.244-1.394-.617-1.786a1.124 1.124 0 0 0-.812-.385 1.152 1.152 0 0 0-.862.44 2.218 2.218 0 0 0-.418.762 3.11 3.11 0 0 0-.15.969Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1827.33 1131.593a3.075 3.075 0 0 0 .18 1.057c.245.664.713 1.113 1.25 1.113.56 0 1.045-.49 1.279-1.202a3.113 3.113 0 0 0 .15-.968c0-.74-.244-1.394-.617-1.786a1.125 1.125 0 0 0-.812-.385c-.56 0-1.046.49-1.28 1.202a3.11 3.11 0 0 0-.15.969Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800.333 1101.81a3.079 3.079 0 0 0 .18 1.056c.245.664.712 1.114 1.25 1.114.556 0 1.039-.483 1.275-1.188a3.106 3.106 0 0 0 .154-.983 3.075 3.075 0 0 0-.18-1.057c-.245-.664-.713-1.113-1.25-1.113-.79 0-1.429.972-1.429 2.17Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830.335 1073.867a3.075 3.075 0 0 0 .18 1.058c.108.29.258.54.437.728a1.125 1.125 0 0 0 .812.384 1.152 1.152 0 0 0 .863-.439c.344-.396.567-1.024.567-1.73 0-.741-.244-1.395-.617-1.787a1.125 1.125 0 0 0-.813-.384c-.789 0-1.429.971-1.429 2.17Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1884.86 1212.266a1.43 2.17 0 1 1 0 1",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Ellipse 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1809.367 1326.311a3.079 3.079 0 0 0 .18 1.057c.244.664.712 1.114 1.25 1.114a1.151 1.151 0 0 0 .861-.44 2.21 2.21 0 0 0 .413-.748 3.109 3.109 0 0 0 .155-.983 3.077 3.077 0 0 0-.181-1.057c-.245-.664-.712-1.113-1.249-1.113-.79 0-1.429.972-1.429 2.17Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.102 1248.687a3.075 3.075 0 0 0 .181 1.057c.245.664.712 1.113 1.25 1.113.789 0 1.428-.971 1.428-2.17 0-.74-.244-1.394-.616-1.785a1.125 1.125 0 0 0-.813-.385c-.56 0-1.045.49-1.28 1.202a3.108 3.108 0 0 0-.15.968Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346.976 1069.855a3.075 3.075 0 0 0 .181 1.058c.107.29.257.54.436.728a1.125 1.125 0 0 0 .813.385 1.152 1.152 0 0 0 .862-.44c.345-.396.568-1.024.568-1.73a3.07 3.07 0 0 0-.181-1.058 2.115 2.115 0 0 0-.437-.728 1.125 1.125 0 0 0-.812-.384c-.79 0-1.43.971-1.43 2.17Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1639.842 1077.735a1.125 1.125 0 0 0 .812.385 1.154 1.154 0 0 0 .866-.443c.174-.201.317-.462.415-.762a3.113 3.113 0 0 0 .15-.965 3.076 3.076 0 0 0-.182-1.058 2.113 2.113 0 0 0-.436-.728 1.126 1.126 0 0 0-.813-.385c-.789 0-1.429.972-1.429 2.17 0 .74.244 1.395.617 1.786Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1493.627 1151.446a1.125 1.125 0 0 0 .813.384c.56 0 1.045-.489 1.28-1.202a3.11 3.11 0 0 0 .15-.968 3.075 3.075 0 0 0-.181-1.057 2.115 2.115 0 0 0-.436-.729 1.125 1.125 0 0 0-.813-.384 1.151 1.151 0 0 0-.862.439 2.218 2.218 0 0 0-.418.763 3.113 3.113 0 0 0-.15.968c0 .74.245 1.394.617 1.786Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464.573 1065.324a1.43 2.17 0 1 1 0 1",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Ellipse 56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1652.625 1223.76a1.126 1.126 0 0 0 .813.385 1.151 1.151 0 0 0 .862-.44c.345-.395.567-1.023.567-1.73 0-.74-.244-1.394-.616-1.786a1.125 1.125 0 0 0-.813-.384c-.56 0-1.045.49-1.28 1.202a3.108 3.108 0 0 0-.15.967c0 .741.244 1.395.617 1.786Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 263"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1582.529 1241.794a1.125 1.125 0 0 0 .812.384 1.151 1.151 0 0 0 .862-.439c.175-.2.319-.462.418-.763a3.113 3.113 0 0 0 .15-.968c0-.74-.244-1.394-.617-1.786a1.125 1.125 0 0 0-.813-.384 1.152 1.152 0 0 0-.862.439c-.345.396-.568 1.024-.568 1.731 0 .74.245 1.394.618 1.786Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1584.77 1025.189a3.075 3.075 0 0 0 .181 1.057c.107.29.257.54.436.728a1.125 1.125 0 0 0 .813.385c.79 0 1.43-.972 1.43-2.17a3.075 3.075 0 0 0-.18-1.058c-.245-.664-.713-1.113-1.25-1.113-.56 0-1.045.49-1.28 1.202a3.11 3.11 0 0 0-.15.969Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1859.244 1047.598a3.075 3.075 0 0 0 .181 1.057c.107.29.257.54.436.728a1.125 1.125 0 0 0 .813.385c.79 0 1.43-.972 1.43-2.17a3.077 3.077 0 0 0-.181-1.058c-.245-.664-.712-1.113-1.249-1.113-.56 0-1.045.49-1.28 1.202a3.11 3.11 0 0 0-.15.969Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1855.671 1080.967a1.125 1.125 0 0 0 .813.384 1.152 1.152 0 0 0 .862-.439c.345-.396.568-1.024.568-1.731a3.075 3.075 0 0 0-.181-1.058 2.114 2.114 0 0 0-.436-.728 1.125 1.125 0 0 0-.813-.384c-.56 0-1.045.489-1.28 1.202a3.113 3.113 0 0 0-.15.968c0 .74.245 1.394.617 1.786Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1826.454 1146.621a3.077 3.077 0 0 0 .18 1.058c.108.29.257.54.437.729a1.126 1.126 0 0 0 .813.384 1.15 1.15 0 0 0 .862-.439c.172-.198.314-.454.412-.75a3.108 3.108 0 0 0 .155-.982 3.073 3.073 0 0 0-.181-1.057 2.115 2.115 0 0 0-.436-.728 1.125 1.125 0 0 0-.812-.384 1.152 1.152 0 0 0-.863.439 2.218 2.218 0 0 0-.417.762 3.108 3.108 0 0 0-.15.968Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1915.971 1238.755a1.125 1.125 0 0 0 .813.384 1.152 1.152 0 0 0 .862-.439c.175-.2.319-.462.418-.762a3.109 3.109 0 0 0 .15-.968c0-1.2-.64-2.17-1.43-2.17-.56 0-1.045.489-1.28 1.201a3.113 3.113 0 0 0-.15.969c0 .74.245 1.393.617 1.785Z",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Path 325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1918.214 1021.65a1.43 2.17 0 1 1 0 1",
    fill: "#bae4ef",
    fillRule: "evenodd",
    "data-name": "Ellipse 69"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/Stars.49a5f16f50d35ff39d127e02c5280a72.svg";
export { ForwardRef as ReactComponent };